// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useRef } from 'react';

import S from './styles';

interface SeekBarProps extends ComponentPropsWithRef<'div'> {
  playedSeconds: number;
  totalDuration: number;
  onSeek: (seconds: number) => void;
}

const SeekBar: React.FC<SeekBarProps> = (props) => {
  const {
    playedSeconds,
    totalDuration,
    onSeek,
    ...otherProps
  } = props;

  const rect = useRef<DOMRect>()

  const handleSeekMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    rect.current = e.currentTarget.getBoundingClientRect();
    handleSeekChange(e.nativeEvent)

    window.addEventListener('mousemove', handleSeekChange);
    window.addEventListener('mouseup', handleSeekMouseUp);
  }

  const handleSeekChange = (e: MouseEvent) => {
    if (!rect.current) return;

    const x = e.clientX - rect.current.x;
    const width = rect.current.width;
    const percentage = Math.min(1, Math.max(0, x / width));
    onSeek(totalDuration * percentage);
  }

  const handleSeekMouseUp = () => {
    window.removeEventListener('mousemove', handleSeekChange);
    window.removeEventListener('mouseup', handleSeekMouseUp);
  }

  return (
    <S.SeekBar onMouseDown={handleSeekMouseDown} {...otherProps}>
      <S.Seek progress={playedSeconds / totalDuration}>
        <S.SeekThumb/>
      </S.Seek>
    </S.SeekBar>
  )
}

export { SeekBar as default }
